import { Modal } from "react-bootstrap";
import LoginModalPage from "./login-voucher-list-pages/LoginModalPage";
import MobileModalPage from "./login-voucher-list-pages/MobileModalPage";
import OtpModalPage from "./login-voucher-list-pages/OtpModalPage";
import VouchersModalPage from "./login-voucher-list-pages/VouchersModalPage";
import ItemVoucherParentPage from "./item-voucher-pages/ItemVoucherParentPage";
import ItemVoucherProductListPage from "./item-voucher-pages/ItemVoucherProductListPage";
import ItemVoucherChildPage from "./item-voucher-pages/ItemVoucherChildPage";
import ConfirmationVoucherAddedToCartPage from "./ConfirmationVoucherAddedToCartPage";

export default function LoyaltyModal(props) {

    let modalBody;

    if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'Login') {
        modalBody = <LoginModalPage
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                        handleClickLoginLoyaltyMobile={props.handleClickLoginLoyaltyMobile}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'Mobile') {
        modalBody = <MobileModalPage
                        loyaltyMember={props.loyaltyMember}
                        handleChangeMobileFields={props.handleChangeMobileFields}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                        handleNextValidateMobile={props.handleNextValidateMobile}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'OTP') {
        modalBody = <OtpModalPage
                        loyaltyMember={props.loyaltyMember}
                        handleBackOtpPage={props.handleBackOtpPage}
                        handleChangeOtpFields={props.handleChangeOtpFields}
                        handleResendOtpToMobile={props.handleResendOtpToMobile}
                        handleNextValidateOtp={props.handleNextValidateOtp}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'Vouchers') {
        modalBody = <VouchersModalPage
                        loyaltyMember={props.loyaltyMember}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                        handleLoyaltyLogout={props.handleLoyaltyLogout}
                        handleSelectVoucher={props.handleSelectVoucher}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'ItemVoucherParent') {
        modalBody = <ItemVoucherParentPage 
                        loyaltyMember={props.loyaltyMember}
                        currentLocation={props.currentLocation}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                        handleBackItemVoucherParent={props.handleBackItemVoucherParent}
                        handleSelectGroupItemVoucherParent={props.handleSelectGroupItemVoucherParent}
                        handleAddVoucherToCartItemVoucherParent={props.handleAddVoucherToCartItemVoucherParent}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'ItemVoucherProductList') {
        modalBody = <ItemVoucherProductListPage 
                        loyaltyMember={props.loyaltyMember}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                        handleBackItemVoucherProductList={props.handleBackItemVoucherProductList}
                        handleSelectProductItemVoucherProductList={props.handleSelectProductItemVoucherProductList}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'ItemVoucherChild') {
        modalBody = <ItemVoucherChildPage 
                        loyaltyMember={props.loyaltyMember}
                        currentLocation={props.currentLocation}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                        handleBackItemVoucherChild={props.handleBackItemVoucherChild}
                        handleModChangeItemVoucherChild={props.handleModChangeItemVoucherChild}
                        handleAddToVoucherItemVoucherChild={props.handleAddToVoucherItemVoucherChild}
                    />
    } else if (props.loyaltyMember.LoyaltyModal.ModalPageShow === 'ConfirmationAddedToCart') {
        modalBody = <ConfirmationVoucherAddedToCartPage
                        loyaltyMember={props.loyaltyMember}
                        handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                    />
    }

    return (
        <Modal show={props.loyaltyMember.LoyaltyModal.ModalIsShown}>
            {modalBody}
        </Modal>
    )
}